<template>
  <main class="main m_promise_main" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="m_promise_wrap">
        <div class="p_top">
          <div class="txt_1">방문약속</div>
          <div class="txt_2" v-if="!disabled">작성일 : {{ todayDate() }}</div>
          <div class="txt_2" v-else>
            작성일 : {{ getCreateAt(mobilePromise.createdAt) }}
          </div>
        </div>
        <div class="p_con">
          <div class="p_con_info">
            <div class="info_title">방문 매장 정보</div>
            <div class="info_con">
              <div class="info_1">{{ shopInfo.name }}</div>
              <div class="info_2">
                <div class="info_2_list">
                  <div class="txt_1">전화번호</div>
                  <div class="txt_2">{{ shopInfo.telNumber }}</div>
                </div>
                <div class="info_2_list">
                  <div class="txt_1">주소</div>
                  <div class="txt_2">
                    {{ shopInfo.address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p_con_info">
            <div class="info_title">
              방문 고객 정보 <span>(고객님 직접 입력)</span>
            </div>
            <div class="info_con" v-if="promiseInfoView">
              <div class="info_3">
                <div class="info_3_list">
                  <div class="txt_1">이름 (본명)</div>
                  <div class="txt_2">
                    <input
                      type="text"
                      v-model="promiseData.name"
                      maxlength="10"
                      :disabled="disabled"
                    />
                  </div>
                </div>
                <div class="info_3_list">
                  <div class="txt_1">휴대폰 번호 (숫자만 입력)</div>
                  <div class="txt_2">
                    <!-- <input
                      type="text"
                      v-model="promiseData.mobile"
                      maxlength="13"
                      :disabled="disabled"
                    /> -->
                    <label class="input">
                      <input
                        type="number"
                        placeholder="숫자만 입력"
                        :disabled="disabled"
                        maxlength="13"
                        v-model="promiseData.mobile"
                        name="mobileNum"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        id="mobileNum"
                      />
                    </label>
                  </div>
                </div>
                <div class="info_3_txt">
                  ※ 기입된 인적사항은 보름 후 비공개됩니다.
                </div>
              </div>
            </div>
            <div class="info_con non_info_con" v-else>
              고객님의 인적사항은 비공개 전환되었습니다.<br /><br />
              내용의 확인을 원하시면<br />고객센터로 문의를 바랍니다
            </div>
          </div>
          <div class="p_con_info">
            <div class="info_title">
              방문 날짜 정보
            </div>
            <div class="info_con">
              <div class="info_4">
                <div class="info_4_list">
                  <div class="txt_1">방문 날짜 선택</div>
                  <div class="txt_2" v-if="!disabled">
                    <div class="txt_2_txt on">
                      <datepicker
                        placeholder="날짜를 선택해주세요"
                        :highlighted="highlighted"
                        v-model="promiseData.dateAll"
                        :value="promiseData.dateAll"
                        :language="ko"
                        :format="datePickerFormat"
                        :open-date="openDate"
                        :disabledDates="disabledDates"
                        @input="setDate()"
                      ></datepicker>
                    </div>
                    <div class="txt_2_img">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_select.svg`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="txt_2 txt_disabled" v-else>
                    <div class="txt_2_txt">
                      {{ promiseData.date }}
                    </div>
                    <div class="txt_2_img">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_select.svg`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="info_4_list">
                  <div class="txt_1">방문 예상시간 선택</div>
                  <div class="txt_2 txt_disabled" v-if="disabled">
                    <div class="txt_2_txt" id="promiseTime">
                      {{ promiseData.time }}
                    </div>
                    <div class="txt_2_img">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_select.svg`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="txt_2" @click="openTimePicker" v-else>
                    <div class="txt_2_txt" id="promiseTime">
                      {{ promiseData.time }}
                    </div>
                    <div class="txt_2_img">
                      <img
                        :src="
                          require(`@/assets/front/images/mobile/i_select.svg`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p_con_info">
            <div class="info_title">
              주의 사항
            </div>
            <div class="info_con">
              <div class="info_5">
                <div class="info_5_list">
                  <div class="txt_1">
                    ★ 방문하고자 하는 날짜/시간에 매장에서 영업을 하는지 먼저
                    확인해주시길 바랍니다.
                  </div>
                  <div class="txt_2">
                    ★ 매장에서 보낸 견적은 통신사 정책에 따라 수 일 혹은 수 시간
                    단위로 변경될 수 있기에 가급적 빠른 시간 내에 매장에
                    방문하시길 추천드립니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="j_agree" v-if="!disabled">
            <div class="checkbox" @click.stop="agreeCheck">
              <input
                type="checkbox"
                id="agree_checkbox"
                v-model="applyChecked"
              />
              <label for="agree_checkbox"
                >개인 정보 제3자 제공에 동의합니다.</label
              >
            </div>
            <p class="j_agree_p">
              ※ 기입하신 정보는 안전하게 보호되며, 해당 매장외는 공개되지
              않습니다.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="btm_btn" v-if="!disabled">
      <div class="btn_wrap" @click="sendPromise">
        <button class="btn">전송하기</button>
      </div>
    </div>
    <TimePickerModal
      ref="timePickerModal"
      @close="closeTimePicker"
      @selectTime="selectTimePicker"
    ></TimePickerModal>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="bottom:7rem;"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
  </main>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import TimePickerModal from '@/front/owner/views/mypage/modal/TimePickerModal';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
export default {
  components: {
    TimePickerModal,
    Datepicker,
  },
  data() {
    return {
      isCompleted: false,
      applyChecked: true,
      isViewToast: false,
      agreeChecked: true,
      // promiseTime: '시간을 선택해주세요',
      // promiseDate: null,
      // datePickerFormat: 'yyyy-MM-dd',
      datePickerFormat: 'M월 dd일 (D요일)',
      ko: ko,
      openDate: new Date(),
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      highlighted: {
        dates: [new Date()],
      },
      promiseData: {
        name: '',
        mobile: '',
        dateAll: '',
        date: '',
        time: '시간을 선택해주세요',
      },
      disabled: true,
      promiseInfoView: true,
      promiseId: this.$route.query.promiseId,
      storeId: this.$route.query.storeId,
    };
  },
  async created() {
    if (!this.promiseId) {
      await this.getStoreInfo(this.storeId);
      this.disabled = false;
    } else {
      await this.getPromiseInfo(this.promiseId);

      this.disabled = true;
      this.promiseData.name = this.mobilePromise.customerName;
      this.promiseData.mobile = this.mobilePromise.customerMobile;
      this.promiseData.date = this.mobilePromise.visitDate;
      this.promiseData.time = this.mobilePromise.visitHour;

      await this.getStoreInfo(this.mobilePromise.storeId);

      this.promiseInfoViewChk(this.mobilePromise.createdAt);
    }

    this.isCompleted = true;
  },
  async mounted() {},
  computed: {
    ...mapGetters({
      shopInfo: shopTypes.SHOP,
    }),
    ...mobileMapGetters({
      mobilePromise: mobileTypes.MOBILE_PROMISE,
    }),
  },
  methods: {
    ...mapActions([shopTypes.FETCH_SHOP]),
    ...mobileMapActions([
      mobileTypes.INSERT_MOBILE_PROMISE,
      mobileTypes.SELECT_MOBILE_PROMISE,
    ]),
    promiseInfoViewChk(createdAt) {
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const cAt = new Date(createdAt);

      const sDays = format(
        new Date(cAt.setDate(cAt.getDate() + 15)),
        'yyyy-MM-dd HH:mm:ss',
      );

      if (now > sDays) {
        this.promiseInfoView = false;
      } else {
        this.promiseInfoView = true;
      }
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    openTimePicker() {
      this.$refs.timePickerModal.isTitle = '방문 시간 선택';
      this.$refs.timePickerModal.isTimeSet = 'start';
      this.$refs.timePickerModal.isOpen = true;
    },
    todayDate() {
      const now = new Date();
      return format(new Date(now.setDate(now.getDate())), 'yyyy-MM-dd');
    },
    setDate() {
      const promiseDateAll = this.promiseData.dateAll;
      var week = new Array(
        '일요일',
        '월요일',
        '화요일',
        '수요일',
        '목요일',
        '금요일',
        '토요일',
      ); // 7, 1, 2, 3, 4, 5, 6
      const promiseDate = new Date(
        promiseDateAll.setDate(promiseDateAll.getDate()),
      );

      this.promiseData.date =
        format(promiseDate, 'MM월 dd일') +
        ' (' +
        week[promiseDate.getDay()] +
        ')';
    },
    async getStoreInfo(storeId) {
      await this[shopTypes.FETCH_SHOP]({ id: storeId });

      console.log('shopInfo');
      console.log(this.shopInfo);
    },
    async getPromiseInfo(promiseId) {
      const params = {
        callPart: this.$route.query.customer ? 'CUSTOMER' : 'OWNER',
        id: promiseId,
      };

      await this[mobileTypes.SELECT_MOBILE_PROMISE](params);
    },
    closeTimePicker() {
      this.$refs.timePickerModal.isOpen = false;
    },
    selectTimePicker() {
      this.promiseData.time =
        this.$refs.timePickerModal.hourStart +
        ':' +
        this.$refs.timePickerModal.minuteStart;

      document.getElementById('promiseTime').classList.add('on');
      this.closeTimePicker();
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    sendPromise() {
      if (!this.promiseData.name.trim()) {
        this.errorMessage = '이름을 확인해 주세요';
        this.toastView();
        return false;
      }

      if (!this.promiseData.mobile.trim()) {
        this.errorMessage = '휴대폰 번호를 확인해 주세요';
        this.toastView();
        return false;
      }

      if (!this.promiseData.date) {
        this.errorMessage = '날짜를 선택해 주세요';
        this.toastView();
        return false;
      }

      if (this.promiseData.time == '시간을 선택해주세요') {
        this.errorMessage = '시간을 선택해 주세요';
        this.toastView();
        return false;
      }

      if (!this.agreeChecked) {
        this.errorMessage = '개인정보 제공 동의가 필요합니다.';
        this.toastView();
        return false;
      }

      const params = {
        storeId: this.storeId,
        customerName: this.promiseData.name,
        customerMobile: this.promiseData.mobile,
        visitDate: this.promiseData.date,
        visitHour: this.promiseData.time,
        chatRoomId: this.$route.query.chatRoomId,
        chatRoomUuid: this.$route.query.chatRoomUuid,
      };

      console.log(params);

      this[mobileTypes.INSERT_MOBILE_PROMISE](params).then(() => {
        this.$router.go(-1);
      });
    },
    agreeCheck() {
      const checkbox = document.getElementById('agree_checkbox');
      this.agreeChecked = checkbox.checked;
    },
  },
};
</script>
